"use client"

import { SnackbarProvider } from "notistack"
import NiceModal from "@ebay/nice-modal-react"

import I18Provider from "@/molecules/i18_provider"
import { init as initAxios } from "@/molecules/axios"
import FavIcon from "@/molecules/fav_icon"
import useInacvtivityCheck from "@/hooks/use_inactivity_check"
import DataLoader from "@/components/data_loader"
import Theme from "@/molecules/theme"
import ErrorBoundary from "@/utils/error_boundary"
import useLatestBuild from "@/hooks/use_latest_build"
import { initAwsRum, SetupRumTestError } from "@/utils/aws_rum"
import Footer from "@/molecules/footer"

const App = ({ children }) => {
  useInacvtivityCheck()
  useLatestBuild("App")
  initAxios()
  initAwsRum()
  // useConfiguration()

  return (
    <I18Provider>
      <FavIcon />
      <Theme>
        <ErrorBoundary>
          <SetupRumTestError />
          <SnackbarProvider
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          />
          <DataLoader>
            <NiceModal.Provider>
              {children}
              <Footer />
            </NiceModal.Provider>
          </DataLoader>
        </ErrorBoundary>
      </Theme>
    </I18Provider>
  )
}

export default App
